import { render, staticRenderFns } from "./SecondDistributorIndex.vue?vue&type=template&id=193b5e18"
import script from "./SecondDistributorIndex.vue?vue&type=script&lang=js"
export * from "./SecondDistributorIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports